module.exports = __webpack_public_path__ + "static/bomba_de_sobrecarga-2a82b640673aebe3c91a45cec4cd6e2c.png";